import { Practitioner } from '~/storm'
import { cleared, mainSurgeon } from '~/utils/waitingListFilters'

import { useBaseCurrentWaitingListForStaffing } from './useBaseCurrentWaitingListForStaffing'

export const useCurrentWaitingListByPractitioner = (practitioner: Practitioner) => {
    const { isLoading, isError, isWaitingListEmpty, surgeriesWithMetadata } = useBaseCurrentWaitingListForStaffing()

    const unScheduledSurgeriesByPractitioner = surgeriesWithMetadata.filter(mainSurgeon([practitioner.short_name]))

    const unScheduledSurgeriesByPractitionerCount = unScheduledSurgeriesByPractitioner.length
    const isWaitingListByPractitionerEmpty = unScheduledSurgeriesByPractitioner.length === 0

    const clearedSurgeriesByPractitionerCount = unScheduledSurgeriesByPractitioner.filter(cleared(['cleared'])).length

    return {
        isLoading,
        isError,
        isWaitingListEmpty,
        unScheduledSurgeriesByPractitioner,
        unScheduledSurgeriesByPractitionerCount,
        isWaitingListByPractitionerEmpty,
        clearedSurgeriesByPractitionerCount,
    }
}
